import { useEffect } from 'react';

import { apiClient } from '../lib/api-client';
import { appEnv } from '../lib/env';
import { registerPwa } from '../lib/pwa';
import { estimateStorage, requestPersistentStorage } from '../lib/storage-persist';
import { useAppStore } from '../stores/app-store';
import { useUserStore } from '../stores/user-store';

export const useAppBootstrap = (): void => {
  const setSession = useUserStore((state) => state.setSession);
  const hydrateFromSettings = useUserStore((state) => state.hydrateFromSettings);
  const setFeatureFlags = useAppStore((state) => state.setFeatureFlags);
  const setLlmStatus = useAppStore((state) => state.setLlmStatus);
  const setNetworkStatus = useAppStore((state) => state.setNetworkStatus);
  const setPwaStatus = useAppStore((state) => state.setPwaStatus);

  useEffect(() => {
    setSession(appEnv.currentUser);
    setFeatureFlags(appEnv.featureFlags);
    setLlmStatus(appEnv.llmCapabilities.currentProvider === 'symbolic-only' ? 'fallback' : 'ready');

    void registerPwa(appEnv.pwaEnabled, {
      onNetworkStatusChange: setNetworkStatus,
      onPwaStatusChange: setPwaStatus,
    });
    void requestPersistentStorage();
    void estimateStorage();

    void apiClient.session().then(setSession).catch(() => undefined);
    void apiClient.settings().then(hydrateFromSettings).catch(() => undefined);
  }, [
    hydrateFromSettings,
    setFeatureFlags,
    setLlmStatus,
    setNetworkStatus,
    setPwaStatus,
    setSession,
  ]);
};
